import "../../styles/chatbot.css";
import chatbotAvatar from "../../assets/Anna_Chat_Avatar.png";
import { useContext, useEffect, useRef, useState } from "react";
import { ChatbotContext } from "../../context/ChatbotContext";
import { useLanguage } from "../../context/LanguageContext";
import ReactHtmlParse from "html-react-parser";
import { FileCheckIcon, ClipboardListIcon } from '../common/icons';
// Import contract icon

// "JUAN CARLOS" → "Juan"; skips initials like "Ma." so Anna never greets someone wrongly
const firstNameOf = (name) => {
  const word = String(name || "").trim().split(/\s+/)[0] || "";
  if (word.length < 2 || word.endsWith(".")) return "";
  return word.toLowerCase().replace(/(^|-)(\p{L})/gu, (m, dash, letter) => dash + letter.toUpperCase());
};

const Message = ({ keyword, speaks, text, userName = "", schoolName = "" }) => {
  const { inputRef, isAgreeTermsConditions } = useContext(ChatbotContext);
  const { language } = useLanguage();
  const tx = (en, fil) => (language === "fil" ? fil : en);
  // Anna introduces herself on the first bubble, by the person's first name and the school's name
  const first = firstNameOf(userName);
  const hi = first ? `Hi, ${first}!` : "Hi!";
  const hiFil = first ? `Kumusta, ${first}!` : "Kumusta!";
  const intro = schoolName
    ? `I'm ANNA, the chat assistant for the ${schoolName} guidance office.`
    : "I'm ANNA, the guidance office's chat assistant.";
  const introFil = schoolName
    ? `Ako si ANNA, ang chat assistant ng ${schoolName} guidance office.`
    : "Ako si ANNA, ang chat assistant ng guidance office.";
  // Once the terms are agreed (remembered for the school year), the first bubble offers the tests
  const agreedTerms = keyword === "terms-conditions" && isAgreeTermsConditions;
  const textRef = useRef(null);
  const [isSingleLine, setIsSingleLine] = useState(false);

  useEffect(() => {
    // Ensure inputRef.current is defined before calling focus
    if (inputRef?.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  // Determine if this bubble renders as a single visual line
  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const compute = () => {
      const styles = window.getComputedStyle(el);
      const lineHeight = parseFloat(styles.lineHeight || "20");
      const height = el.clientHeight;
      setIsSingleLine(height <= lineHeight * 1.6); // tolerate slight rounding
    };

    // compute after paint
    const id = requestAnimationFrame(compute);
    window.addEventListener("resize", compute);
    return () => {
      cancelAnimationFrame(id);
      window.removeEventListener("resize", compute);
    };
  }, [text]);

  const openTerms = (e) => {
    e.preventDefault();
    const modal = new bootstrap.Modal(
      document.getElementById("modal-terms-conditions"),
    );
    modal.show();
  };

  const termsLink = (title) => (
    <a className="terms-conditions-link" href="#" onClick={openTerms} title={title}>
      terms and conditions
    </a>
  );

  return (
    <>
      <div
        className={`message ${speaks !== "bot" && "user"} ${isSingleLine ? "single-line" : ""}`}
      >
        {speaks === "bot" && (
          <div>
            <img
              className="chatbot-avatar message-avatar"
              src={chatbotAvatar}
              alt="chathead"
            />
          </div>
        )}
        <div
          ref={textRef}
          className={`message-text ${speaks === "bot" ? "bot" : "user"}`}
        >
          {keyword === "terms-conditions" ? (
            <>
              {tx(`${hi} 👋 ${intro}`, `${hiFil} 👋 ${introFil}`)}{" "}
              {agreedTerms ? (
                <>
                  {tx(
                    "I'll take you through your tests one question at a time. There are no right or wrong answers. Pick a test when you're ready. 😊",
                    "Isa-isa nating sasagutin ang mga test mo. Walang tama o maling sagot. Pumili ng test kapag handa ka na. 😊",
                  )}
                  <button
                    type="button"
                    className="cb-action is-choose"
                    onClick={() => window.dispatchEvent(new Event("anna:choose-test"))}
                  >
                    <ClipboardListIcon size={18} />
                    {tx("Choose a test", "Pumili ng test")}
                  </button>
                  <span className="cb-terms-note">
                    {tx("You've agreed to the ", "Sumang-ayon ka na sa ")}
                    {termsLink("Read the terms and conditions again")}.
                  </span>
                </>
              ) : (
                <>
                  {tx("Before we start, read and agree to the ", "Bago tayo magsimula, basahin at sumang-ayon muna sa ")}
                  {termsLink("Read and agree to the terms and conditions")}
                  {tx(
                    ". They explain the information I'll ask for and how it's used. 😊",
                    ". Dito nakasulat kung anong impormasyon ang itatanong ko at paano ito gagamitin. 😊",
                  )}
                  <button type="button" className="cb-action" onClick={openTerms}>
                    <FileCheckIcon size={18} />
                    {tx("Read the terms", "Basahin ang terms")}
                  </button>
                </>
              )}
            </>
          ) : (
            <>{ReactHtmlParse(text.toString())}{" "}</>
          )}
        </div>
      </div>
    </>
  );
};

export default Message;
